{
  "version": 1,
  "asset_id": "166bf8cf-0c89-4086-8382-cd9707ed1939",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/166bf8cf-0c89-4086-8382-cd9707ed1939/svc-saas-seo-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/166bf8cf-0c89-4086-8382-cd9707ed1939/svc-saas-seo-640.avif",
  "original_filename": "svc-saas-seo-640.avif",
  "size": 6279,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:58Z"
}
